import UserEnterpriseLogo from './UserEnterpriseLogo.component';

export default UserEnterpriseLogo;